<template>
  <button
    :class="[btnPaymentDisabled]"
    class="btn btn-web"
    @click="onClickPayment()"
  >
    {{ currencyFormatter(totalNumber, { code: currency }) }}
  </button>
</template>

<script>
import totalPriceMixin from '@/mixins/pos/totalPrice'

export default {
  mixins: [totalPriceMixin],
}
</script>

<style scoped>
.btn.over-99 {
  font-size: 11px;
}
</style>



// WEBPACK FOOTER //
// src/components/apps/pos/sale/mobile/common/TotalPriceButton.vue